import { render } from "./WebHeader.vue?vue&type=template&id=5b158b46&scoped=true"
import script from "./WebHeader.vue?vue&type=script&lang=js"
export * from "./WebHeader.vue?vue&type=script&lang=js"

import "./WebHeader.vue?vue&type=style&index=0&id=5b158b46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b158b46"]])

export default __exports__